import {
  BreakpointAction,
  ChoiceFunction,
  QuizDataInput,
  SideEffectsBreakpointOption,
} from '@naturalcycles/shared'
import { Page } from '@src/app/shared/typings/enum/pages.js'
import { allQuizSections } from '../quiz.js'

const yesTransformFunction: ChoiceFunction<Page, QuizDataInput> = flow => {
  if (!flow[allQuizSections.goal]!.includes(Page.sideEffectsInfo)) {
    flow[allQuizSections.goal] = [...flow[allQuizSections.goal]!, Page.sideEffectsInfo]
  }
  return flow
}

const noTransformFunction: ChoiceFunction<Page, QuizDataInput> = flow => {
  const position = flow[allQuizSections.goal]!.indexOf(Page.sideEffectsInfo)
  if (position !== -1) flow[allQuizSections.goal]!.splice(position, 1)
  return flow
}

export const sideEffects: BreakpointAction<SideEffectsBreakpointOption, Page, QuizDataInput> = {
  [SideEffectsBreakpointOption.depression]: yesTransformFunction,
  [SideEffectsBreakpointOption.heavierPeriods]: yesTransformFunction,
  [SideEffectsBreakpointOption.lossOfLibido]: yesTransformFunction,
  [SideEffectsBreakpointOption.headaches]: yesTransformFunction,
  [SideEffectsBreakpointOption.skin]: yesTransformFunction,
  [SideEffectsBreakpointOption.tenderBreasts]: yesTransformFunction,
  [SideEffectsBreakpointOption.moodSwings]: yesTransformFunction,
  [SideEffectsBreakpointOption.weightGain]: yesTransformFunction,
  [SideEffectsBreakpointOption.irregularBleeding]: yesTransformFunction,
  [SideEffectsBreakpointOption.skip]: noTransformFunction,
}
